/* eslint-disable max-len */
/* eslint-disable no-useless-escape */
import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { generateApiParameters } from '../../../utils/constants';

class APIPixel extends Component {
  render() {
    const { pixel } = this.props;
    const tableHeader = ['Parameter', 'Type', 'Required', 'Description'];
    const parameterInformation = generateApiParameters(pixel);

    return (
      <div>
        <p>To retrieve jobs from the JobAdX API you must create a <b>POST</b> request to: </p>
        <pre>https://api.jobadx.com/v1/exchange/auctions</pre>
        <h3>Prerequisites</h3>
        <ul>
          <li>
            In order for us to provide the most relevant jobs for your site you will need to generate
            a unique ID to identify your users.
          </li>
          <li>
            You will also need to pass in your Pixel ID (<strong>{pixel.data && pixel.data.uuid}</strong>) 
            in the parameter for us to identify your website.
          </li>
        </ul>
        <br />
        <h3>Request Parameters</h3>
        <div style={{ overflowX: 'auto' }}>
          <Table bordered>
            <thead>
              <tr>
                {tableHeader.map((header, i) => {
                  return (<th key={i}> {header} </th>);
                })}
              </tr>
            </thead>
            <tbody>
              {parameterInformation.map((parameter, i) => {
                return (<tr key={i}>
                  <td>
                    {parameter.parameter}
                  </td>
                  <td>
                    {parameter.type}
                  </td>
                  <td>
                    {parameter.required}
                  </td>
                  <td>
                    {parameter.description}
                  </td>
                </tr>);
              })}
            </tbody>
          </Table>
        </div>
        <h3>Search Request Example</h3>
          Sample HTTP Request:
          <pre>
            POST /v1/exchange/auctions HTTP/1.1<br />
            Content-Type: application/json<br />

            {'{'}<br />
              {`  "pid":"${pixel.data && pixel.data.uuid}"`},<br />
              {'  "uid":"h94a09s7-301e-46d4-835a-d34537cb96d4",'}<br />
              {'  "ip":"34.56.32.2",'}<br />
              {'  "useragent":"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/69.0.3497.100 Safari/537.36",'}<br />
              {'  "keyword":"Sales",'}<br />
              {'  "location":"New York",'}<br />
              {'  "slots":10'}<br />
            {'}'}
          </pre>
          Sample cURL Request:
          <pre>
            {`curl --location --request POST "https://api.jobadx.com/v1/exchange/auctions" \\\n\
              --header "Content-Type: application/json" \\\n\
              --data "\{ \n \
              \\\"pid\\\": \\\"${pixel.data && pixel.data.uuid}\\\"\,\n\
              \\\"uid\\\": \\\"h94a09s7-301e-46d4-835a-d34537cb96d4\\\"\,\n\
              \\\"ip\\\": \\\"34.56.32.2\\\"\,\n\
              \\\"useragent\\\": \\\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/69.0.3497.100 Safari/537.36\\\"\,\\\n \
              \\\"slots\\\": 2\,\n\
              \\\"ref_url\\\": \\\"https://google.com\\\"\,\n\
              \\\"url\\\": \\\"https://google.com\\\"\,\n\
              \\\"keyword\\\": \\\"sales\\\"\,\n\
              \\\"location\\\": \\\"new york\\\"\n\
            \}"`}
          </pre>
        <h3>Search Request Response</h3>
        <pre>
          {'200 - OK \n'}
          {'{\n'}
          {'  data:[\n'}
          {'    {\n'}
          {'      "id": "263854927",\n'}
          {'      "title": "Sales Consultant",\n'}
          {'      "description": "Bill Rapp Superstore is hiring and we want to talk to you!\\n\\n\\nAre you ready to jump-start your career and grow within our organization? Bill Rapp Superstore is a leader in automotive retail and we are looking to add qualified AUTOMOTIVE SALES PROFESSIONALS to our team...",\n'}
          {'      "company": "Bill Rapp Superstore",\n'}
          {'      "location": "13206, Syracuse, New York, United States",\n'}
          {'      "url": "http://api.jobadx.com/aclk?ai=3bef7ea8-321c-4c45-a4f6-0a287cf1c95f&utoken=2a7df3d9-8eb9-4ff2-b2d7-f7a08fb9f900&vistoken=2a940f1a-5026-4e12-afeb-385e09134984&ac=174&c=bill%20rapp%20superstore&st=cpc",\n'}
          {'      "date": "2018-04-16T00:00:00.000000000+00:00",\n'}
          {'      "slot_id": "h94a09s7-301e-46d4-835a-d34537cb96d4-1"\n'}
          {'    }\n'}
          {'    {\n'}
          {'      "id": "386305029",\n'}
          {'      "title": "Sales Associate - Lodge",\n'}
          {'      "description": "Description \\n\\nWe are genuine in our belief that sports make people better and so are you!  Immerse yourself in a workplace that loves to be active and lives the brand...",\n'}
          {'      "company": "Dicks Sporting Goods Golf Galaxy",\n'}
          {'      "location": "Bay Shore, NY, United States",\n'}
          {'      "url": "http://api.jobadx.com/aclk?ai=de633647-4904-4079-b419-6f5711c5f45a&utoken=2a7df3d9-8eb9-4ff2-b2d7-f7a08fb9f900&vistoken=2a940f1a-5026-4e12-afeb-385e09134984&ac=172&c=dicks%20sporting%20goods%20golf%20galaxy&st=cpc",\n'}
          {'      "date": "2018-10-23T00:00:00.000000000+00:00",\n'}
          {'      "slot_id": "h94a09s7-301e-46d4-835a-d34537cb96d4-2"\n'}
          {'    }\n'}
          {'  ]\n'}
          {'}'}
        </pre>
      </div>
    );
  }
}

export default APIPixel;
